// extracted by mini-css-extract-plugin
export default {"detailSectionContainer":"DetailsSection_detailSectionContainer__9-1J1","titleWrapper":"DetailsSection_titleWrapper__7c-xP"};